import { useCallback, useState } from 'react';
import { debounce, InputAdornment } from '@mui/material';
import { Search } from 'lucide-react';

import { StyledTextField } from '@labradorsports/components';

import GlobalSearchResults from '../global-search-results/global-search-results.js';

interface Props {
    inputRef?: React.RefObject<HTMLInputElement>;
}

const GlobalSearchBox: FC<Props> = ({ inputRef }) => {
    const [search, setSearch] = useState('');
    const [loadedSearch, setLoadedSearch] = useState('');

    const debouncedSearch = useCallback(
        debounce((str: string) => {
            setLoadedSearch(str);
        }, 500),
        []
    );

    const searchChange = (evt) => {
        setSearch(evt.target.value);

        debouncedSearch(evt.target.value);

        if (evt.target.value === '') {
            setLoadedSearch('');
        }
    };

    const keyDown = (evt: any) => {
        if (evt.key === 'Enter' && search !== '') {
            setLoadedSearch('');
        }
    };

    const onHide = () => {
        setSearch('');
        setLoadedSearch('');
    };

    return (
        <div className="global-search-box">
            <StyledTextField
                label="Search"
                value={search}
                onChange={searchChange}
                onKeyDown={keyDown}
                inputRef={inputRef}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search className="button-icon search-icon" />
                        </InputAdornment>
                    ),
                }}
            />
            {loadedSearch !== '' ? <GlobalSearchResults query={loadedSearch} onHide={onHide} /> : null}
        </div>
    );
};

export default GlobalSearchBox;
